export enum CartSideBarPreviewMode {
  OnlyProducts,
  Full,
}
